import LockClosedIcon from '@heroicons/react/solid/LockClosedIcon'
import clsx from 'clsx'

import { T } from '@tribeplatform/react-components/i18n'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const SpacePrivacyIcon = ({ space, size = 'md' }) => {
  const sizes = [size === 'md' && 'w-5 h-5', size === 'sm' && 'w-4 h-4']
  if (space.private) {
    return (
      <Tooltip>
        <Tooltip.Trigger>
          <LockClosedIcon
            className={clsx(
              'text-content-subdued hover:text-content-hovered',
              sizes,
            )}
          />
        </Tooltip.Trigger>
        <Tooltip.Panel>
          <T defaultMessage="Private {SPACE}" id="Generics.PrivateSpace" />
        </Tooltip.Panel>
      </Tooltip>
    )
  }
  return null
}
